import { Transaction } from '@/api/general';

export const findTransactionStatus = (transaction: Transaction) => {
    let currentStatus;
    if (transaction.type === 'bank') {
        currentStatus = transaction?.bankTransaction?.status;
    }
    if (transaction.type === 'card') {
        currentStatus =
            transaction?.cardTransaction?.type === 'purchase'
                ? transaction?.cardTransaction?.status
                : transaction?.cardTransaction?.authStatus;
    }
    return currentStatus || '';
};
